<div class="explore-container">
    <!-- Filters -->
    <div class="filters">
      <div *ngFor="let filter of filters"
           (click)="selectFilter(filter)"
           [class.active]="activeFilter === filter">
        {{ filter }}
      </div>
    </div>
  
    <!-- Jump Back In -->
    <h2>Jump back in</h2>
    <div class="horizontal-scroll">
      <div *ngFor="let item of jumpBackIn" class="jump-card" [ngClass]="item.type">
        <img [src]="item.imageUrl" alt="{{ item.title }}">
        <div class="title">{{ item.title }}</div>
        <div class="subtitle" *ngIf="item.artist">{{ item.artist }}</div>
      </div>
    </div>
  
    <!-- Best of Artists -->
    <h2>Best of artists</h2>
    <div class="horizontal-scroll">
      <div *ngFor="let artist of bestOfArtists" class="artist-card">
        <img [src]="artist.imageUrl" alt="{{ artist.title }}">
        <div class="artist-title">{{ artist.title }}</div>
        <div class="artist-description">{{ artist.description }}</div>
      </div>
    </div>
  
    <!-- Recents -->
    <h2>Recents <span class="show-all">Show all</span></h2>
    <div class="recents-bar" [class.playing]="recents.playing">
      <div class="track-info">
        <div class="track-title">{{ recents.title }} • {{ recents.artist }}</div>
        <div class="device">🎧 {{ recents.device }}</div>
      </div>
      <button (click)="togglePlay()">
        {{ recents.playing ? '❚❚' : '▶' }}
      </button>
    </div>
  
    <!-- Bottom Navigation -->
    <nav class="bottom-nav">
      <div class="nav-item active">🏠<span>Home</span></div>
      <div class="nav-item">🔍<span>Search</span></div>
      <div class="nav-item">📚<span>Your Library</span></div>
    </nav>
  </div>
  